/* ============================================================
   MONNAIE DU MONDE — produit-galerie.js
   Galerie de la fiche produit :
   - défilement (flèches au survol, vignettes, points, compteur, clavier, balayage tactile) ;
   - zoom au survol (loupe qui suit la souris, niveau réglable) ;
   - plein écran au clic / au tap : zoom molette / pincement / double-clic, déplacement au glisser,
     navigation entre images, Échap, focus piégé, aria-modal ;
   - détection des photos à fond blanc (fusion « multiply » automatique).
   Réglages lus sur [data-galerie] : data-zoom (aucun|survol|clic|les-deux), data-zoom-niveau (ex. 2.5),
   data-fusion (auto|aucune|multiply), data-textes (JSON des libellés, issus de locales/fr.default.json).
   Idempotent, compatible éditeur de thème (shopify:section:load) et sans erreur si la galerie est absente.
   ============================================================ */
(function () {
  'use strict';
  if (window.mdmInitGalerie) { window.mdmInitGalerie(document); return; }

  var REDUIT = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SOURIS = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function borne(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function el(tag, classe, attrs) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    return e;
  }
  function icone(chemin, taille) {
    return '<svg width="' + (taille || 20) + '" height="' + (taille || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + chemin + '</svg>';
  }

  /* ---------- photo à fond blanc ? (sonde de 48 px, même origine ou CORS Shopify) ---------- */
  function surFondBlanc(url, rappel) {
    var sonde = new Image();
    sonde.crossOrigin = 'anonymous';
    sonde.onload = function () {
      try {
        var w = Math.min(48, sonde.naturalWidth || 48), h = Math.min(48, sonde.naturalHeight || 48);
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(sonde, 0, 0, w, h);
        var px = x.getImageData(0, 0, w, h).data;
        var blanc = function (i, j) {
          var k = (j * w + i) * 4;
          return px[k + 3] >= 250 && px[k] >= 236 && px[k + 1] >= 236 && px[k + 2] >= 236;
        };
        var total = 0, blancs = 0, coins = 0;
        for (var j = 0; j < h; j++) {
          for (var i = 0; i < w; i++) {
            if (j > 1 && j < h - 2 && i > 1 && i < w - 2) continue;   /* anneau extérieur seulement */
            total++;
            if (blanc(i, j)) blancs++;
          }
        }
        /* les 4 coins (3 × 3 px) doivent être blancs et opaques */
        [[0, 0], [w - 3, 0], [0, h - 3], [w - 3, h - 3]].forEach(function (c) {
          for (var dj = 0; dj < 3; dj++) for (var di = 0; di < 3; di++) if (blanc(c[0] + di, c[1] + dj)) coins++;
        });
        /* une photo détourée (alpha < 250 sur le pourtour) ou sur fond coloré ne passe jamais ces seuils */
        rappel(total > 0 && blancs / total >= 0.75 && coins >= 34);
      } catch (e) { rappel(false); }
    };
    sonde.onerror = function () { rappel(false); };
    sonde.src = url;
  }

  /* ============================================================
     VISIONNEUSE PLEIN ÉCRAN (une seule pour la page)
     ============================================================ */
  var lb = null;

  function creerLightbox(textes) {
    var racine = el('div', 'lightbox', { role: 'dialog', 'aria-modal': 'true', 'aria-label': textes.visionneuse || 'Visionneuse d’images' });
    racine.hidden = true;
    racine.innerHTML =
      '<div class="lightbox__scene" data-lb-scene><img class="lightbox__img" alt="" draggable="false"></div>' +
      '<p class="lightbox__compteur" aria-live="polite" data-lb-compteur></p>' +
      '<div class="lightbox__outils" role="group">' +
        '<button type="button" class="lightbox__btn" data-lb-moins aria-label="' + (textes.dezoomer || 'Dézoomer') + '">' + icone('<circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.9-4.9M8 10.5h5"/>') + '</button>' +
        '<button type="button" class="lightbox__btn" data-lb-plus aria-label="' + (textes.zoomer || 'Zoomer') + '">' + icone('<circle cx="10.5" cy="10.5" r="6.5"/><path d="m20 20-4.9-4.9M10.5 8v5M8 10.5h5"/>') + '</button>' +
        '<button type="button" class="lightbox__btn" data-lb-reinit aria-label="' + (textes.tailleOrigine || 'Taille d’origine') + '">' + icone('<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>') + '</button>' +
      '</div>' +
      '<button type="button" class="lightbox__fermer" data-lb-fermer aria-label="' + (textes.fermer || 'Fermer') + '">' + icone('<path d="M5 5l14 14M19 5 5 19"/>', 22) + '</button>' +
      '<button type="button" class="lightbox__nav lightbox__nav--g" data-lb-prec aria-label="' + (textes.precedent || 'Image précédente') + '">' + icone('<path d="M15 4 7 12l8 8"/>', 24) + '</button>' +
      '<button type="button" class="lightbox__nav lightbox__nav--d" data-lb-suiv aria-label="' + (textes.suivant || 'Image suivante') + '">' + icone('<path d="m9 4 8 8-8 8"/>', 24) + '</button>';
    document.body.appendChild(racine);

    var scene = racine.querySelector('[data-lb-scene]');
    var img = racine.querySelector('.lightbox__img');
    var compteur = racine.querySelector('[data-lb-compteur]');
    var etat = { g: null, idx: 0, s: 1, tx: 0, ty: 0, declencheur: null, vue: null };
    var pointeurs = {};            /* pointerId -> {x, y} */
    var pincement = null;          /* {dist, s, tx, ty, mx, my} */
    var glisse = null;             /* {x, y, tx, ty, moved} */
    var dernierTap = 0;

    function taille() {
      return { w: img.clientWidth || 1, h: img.clientHeight || 1, W: scene.clientWidth || 1, H: scene.clientHeight || 1 };
    }
    function limiter() {
      var t = taille();
      var mx = Math.max(0, (t.w * etat.s - t.W) / 2 + (etat.s > 1 ? 40 : 0));
      var my = Math.max(0, (t.h * etat.s - t.H) / 2 + (etat.s > 1 ? 40 : 0));
      if (etat.s <= 1.001) { mx = Math.max(0, mx); my = Math.max(0, my); }
      etat.tx = borne(etat.tx, -mx, mx);
      etat.ty = borne(etat.ty, -my, my);
    }
    function dessiner(anime) {
      img.style.transition = anime && !REDUIT ? 'transform .28s cubic-bezier(.22,.9,.3,1)' : 'none';
      img.style.transform = 'translate(' + etat.tx + 'px,' + etat.ty + 'px) scale(' + etat.s + ')';
      racine.classList.toggle('est-zoome', etat.s > 1.001);
    }
    /* zoom en gardant le point (px, py) — relatif au centre de la scène — fixe à l'écran */
    function zoomerEn(s2, px, py, anime) {
      s2 = borne(s2, 1, 6);
      var q = { x: (px - etat.tx) / etat.s, y: (py - etat.ty) / etat.s };
      etat.s = s2;
      etat.tx = px - q.x * s2;
      etat.ty = py - q.y * s2;
      if (s2 <= 1.001) { etat.s = 1; etat.tx = 0; etat.ty = 0; }
      limiter();
      dessiner(anime);
    }
    function reinit(anime) { etat.s = 1; etat.tx = 0; etat.ty = 0; dessiner(anime); }

    function appliquerVue() {
      /* vues « détail » générées : on ouvre déjà cadré comme la vignette */
      var v = etat.vue;
      if (!v || !(+v.zoom > 1)) { reinit(false); return; }
      var t = taille();
      etat.s = +v.zoom;
      etat.tx = etat.s * (+v.x / 100) * t.w;
      etat.ty = etat.s * (+v.y / 100) * t.h;
      limiter();
      dessiner(false);
    }

    function montrer(i) {
      var diapos = etat.g.diapos;
      etat.idx = (i + diapos.length) % diapos.length;
      var d = diapos[etat.idx];
      var src = d.getAttribute('data-zoom-src');
      var apercu = d.querySelector('img');
      etat.vue = d.getAttribute('data-vue') ? { zoom: d.getAttribute('data-vue-zoom'), x: d.getAttribute('data-vue-x'), y: d.getAttribute('data-vue-y') } : null;
      img.alt = apercu ? apercu.alt : '';
      reinit(false);
      /* aperçu immédiat (déjà en cache) puis haute définition */
      if (apercu && (apercu.currentSrc || apercu.src)) img.src = apercu.currentSrc || apercu.src;
      var hd = new Image();
      hd.onload = function () {
        if (diapos[etat.idx] === d) { img.src = src; requestAnimationFrame(appliquerVue); }
      };
      hd.src = src;
      if (img.complete) requestAnimationFrame(appliquerVue); else img.onload = function () { appliquerVue(); };
      compteur.textContent = diapos.length > 1 ? (etat.idx + 1) + ' / ' + diapos.length : '';
      racine.classList.toggle('lightbox--seule', diapos.length < 2);
    }

    function focusables() {
      return Array.prototype.slice.call(racine.querySelectorAll('button')).filter(function (b) { return b.offsetParent !== null; });
    }
    function ouvrir(g, i, declencheur) {
      etat.g = g; etat.declencheur = declencheur || document.activeElement;
      var fond = g.racine ? window.getComputedStyle(g.racine).getPropertyValue('--lightbox-fond') : '';
      racine.style.setProperty('--lightbox-fond', fond ? fond.trim() : '');
      racine.hidden = false;
      document.documentElement.classList.add('lightbox-ouverte');
      montrer(i);
      requestAnimationFrame(function () { racine.classList.add('est-ouvert'); });
      racine.querySelector('[data-lb-fermer]').focus();
    }
    function fermer() {
      if (racine.hidden) return;
      racine.classList.remove('est-ouvert');
      document.documentElement.classList.remove('lightbox-ouverte');
      var g = etat.g, idx = etat.idx, retour = etat.declencheur;
      window.setTimeout(function () { racine.hidden = true; img.removeAttribute('src'); }, REDUIT ? 0 : 220);
      if (g) g.aller(idx, true);
      if (retour && retour.focus) retour.focus();
    }

    /* --- commandes --- */
    racine.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (b) {
        if (b.hasAttribute('data-lb-fermer')) fermer();
        else if (b.hasAttribute('data-lb-prec')) montrer(etat.idx - 1);
        else if (b.hasAttribute('data-lb-suiv')) montrer(etat.idx + 1);
        else if (b.hasAttribute('data-lb-plus')) zoomerEn(etat.s * 1.5, 0, 0, true);
        else if (b.hasAttribute('data-lb-moins')) zoomerEn(etat.s / 1.5, 0, 0, true);
        else if (b.hasAttribute('data-lb-reinit')) reinit(true);
        return;
      }
      /* clic dans le vide autour de l'image (sans avoir déplacé) : fermer */
      if (e.target === scene && etat.s <= 1.001 && !(glisse && glisse.moved)) fermer();
    });
    racine.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); fermer(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(etat.idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); montrer(etat.idx + 1); }
      else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomerEn(etat.s * 1.5, 0, 0, true); }
      else if (e.key === '-' || e.key === '_') { e.preventDefault(); zoomerEn(etat.s / 1.5, 0, 0, true); }
      else if (e.key === '0') { e.preventDefault(); reinit(true); }
      else if (e.key === 'Tab') {                                  /* focus piégé */
        var f = focusables();
        if (!f.length) return;
        var premier = f[0], dernier = f[f.length - 1];
        if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
        else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
        else if (!racine.contains(document.activeElement)) { e.preventDefault(); premier.focus(); }
      }
    });

    /* molette : zoom centré sur le curseur */
    scene.addEventListener('wheel', function (e) {
      e.preventDefault();
      var r = scene.getBoundingClientRect();
      var px = e.clientX - r.left - r.width / 2, py = e.clientY - r.top - r.height / 2;
      zoomerEn(etat.s * Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0018)), px, py, false);
    }, { passive: false });

    /* pointeurs : glisser (déplacement / changement d'image), pincement, double-clic / double-tap */
    scene.addEventListener('pointerdown', function (e) {
      pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
      scene.setPointerCapture(e.pointerId);
      var ids = Object.keys(pointeurs);
      if (ids.length === 2) {
        var a = pointeurs[ids[0]], b = pointeurs[ids[1]];
        var r = scene.getBoundingClientRect();
        pincement = { dist: Math.hypot(a.x - b.x, a.y - b.y), s: etat.s, tx: etat.tx, ty: etat.ty,
          mx: (a.x + b.x) / 2 - r.left - r.width / 2, my: (a.y + b.y) / 2 - r.top - r.height / 2 };
        glisse = null;
      } else if (ids.length === 1) {
        glisse = { x: e.clientX, y: e.clientY, tx: etat.tx, ty: etat.ty, moved: false };
      }
    });
    scene.addEventListener('pointermove', function (e) {
      if (!pointeurs[e.pointerId]) return;
      pointeurs[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(pointeurs);
      if (ids.length === 2 && pincement) {
        var a = pointeurs[ids[0]], b = pointeurs[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        var s2 = borne(pincement.s * d / pincement.dist, 1, 6);
        var q = { x: (pincement.mx - pincement.tx) / pincement.s, y: (pincement.my - pincement.ty) / pincement.s };
        etat.s = s2; etat.tx = pincement.mx - q.x * s2; etat.ty = pincement.my - q.y * s2;
        limiter(); dessiner(false);
      } else if (glisse) {
        var dx = e.clientX - glisse.x, dy = e.clientY - glisse.y;
        if (Math.abs(dx) + Math.abs(dy) > 5) glisse.moved = true;
        if (etat.s > 1.001) {
          etat.tx = glisse.tx + dx; etat.ty = glisse.ty + dy;
          limiter(); dessiner(false);
        } else if (glisse.moved && Math.abs(dx) > Math.abs(dy)) {
          img.style.transition = 'none';
          img.style.transform = 'translate(' + dx * 0.5 + 'px,0)';
        }
      }
    });
    function fin(e) {
      if (!pointeurs[e.pointerId]) return;
      var avant = pointeurs[e.pointerId];
      delete pointeurs[e.pointerId];
      if (Object.keys(pointeurs).length < 2) pincement = null;
      if (glisse && Object.keys(pointeurs).length === 0) {
        var dx = e.clientX - glisse.x;
        if (etat.s <= 1.001 && glisse.moved && Math.abs(dx) > 60 && e.type === 'pointerup') montrer(etat.idx + (dx < 0 ? 1 : -1));
        else if (etat.s <= 1.001) dessiner(true);
        else limiter();
        /* double-clic / double-tap */
        if (!glisse.moved && e.type === 'pointerup' && e.target === img) {
          var maintenant = Date.now();
          if (maintenant - dernierTap < 320) {
            var r = scene.getBoundingClientRect();
            if (etat.s > 1.001) reinit(true);
            else zoomerEn(2.6, avant.x - r.left - r.width / 2, avant.y - r.top - r.height / 2, true);
            dernierTap = 0;
          } else dernierTap = maintenant;
        }
        window.setTimeout(function () { glisse = null; }, 0);
      }
    }
    scene.addEventListener('pointerup', fin);
    scene.addEventListener('pointercancel', fin);
    img.addEventListener('dblclick', function (e) { e.preventDefault(); });
    window.addEventListener('resize', function () { if (!racine.hidden) { limiter(); dessiner(false); } });

    return { ouvrir: ouvrir, fermer: fermer };
  }

  /* ============================================================
     GALERIE
     ============================================================ */
  function creer(g) {
    var textes = {};
    try { textes = JSON.parse(g.getAttribute('data-textes') || '{}'); } catch (e) { textes = {}; }
    var principale = g.querySelector('.galerie__principale');
    var piste = g.querySelector('[data-galerie-piste]');
    var diapos = Array.prototype.slice.call(g.querySelectorAll('[data-galerie-image]'));
    var vignettes = Array.prototype.slice.call(g.querySelectorAll('[data-vignette]'));
    var points = Array.prototype.slice.call(g.querySelectorAll('[data-point]'));
    var compteur = g.querySelector('[data-galerie-compteur]');
    var annonce = g.querySelector('[data-galerie-annonce]');
    var n = diapos.length;
    var mode = g.getAttribute('data-zoom') || 'clic';
    var zoomSurvol = SOURIS && (mode === 'survol' || mode === 'les-deux');
    var zoomClic = mode === 'clic' || mode === 'les-deux';
    var niveau = Math.min(4, Math.max(1.5, parseFloat(g.getAttribute('data-zoom-niveau')) || 2.5));
    var idx = 0;
    var api = { diapos: diapos, racine: g };

    function formater(modele, valeurs) {
      return String(modele || '').replace(/\{(\w+)\}/g, function (m, k) { return valeurs[k] != null ? valeurs[k] : m; });
    }

    function precharger(i) {
      var d = diapos[i];
      if (!d) return;
      var im = d.querySelector('img');
      if (im && im.getAttribute('loading') === 'lazy') { im.setAttribute('loading', 'eager'); }
    }

    /* fait défiler la rangée de vignettes (jamais la page) pour montrer la vignette active */
    function centrerVignette(v) {
      var c = v && v.parentElement;
      if (!c) return;
      if (c.scrollWidth > c.clientWidth + 1) c.scrollLeft = v.offsetLeft - (c.clientWidth - v.offsetWidth) / 2;
      if (c.scrollHeight > c.clientHeight + 1) c.scrollTop = v.offsetTop - (c.clientHeight - v.offsetHeight) / 2;
    }

    function aller(i, silencieux) {
      if (!n) return;
      var precedent = idx;
      idx = ((i % n) + n) % n;
      if (piste) piste.style.setProperty('--i', idx);
      diapos.forEach(function (d, j) {
        d.classList.toggle('est-actif', j === idx);
        if (j === idx) d.removeAttribute('aria-hidden'); else d.setAttribute('aria-hidden', 'true');
      });
      vignettes.forEach(function (v, j) {
        v.classList.toggle('est-actif', j === idx);
        if (j === idx) v.setAttribute('aria-current', 'true'); else v.removeAttribute('aria-current');
      });
      points.forEach(function (p, j) { p.classList.toggle('est-actif', j === idx); });
      if (compteur) compteur.textContent = (idx + 1) + ' / ' + n;
      if (annonce && !silencieux) annonce.textContent = formater(textes.imageNSurTotal || 'Image {n} sur {total}', { n: idx + 1, total: n });
      if (!silencieux) centrerVignette(vignettes[idx]);
      precharger(idx + 1); precharger(idx - 1);
      if (precedent !== idx) sortirLoupe();
    }
    api.aller = aller;

    /* --- flèches, vignettes, points --- */
    var prec = g.querySelector('[data-galerie-prec]'), suiv = g.querySelector('[data-galerie-suiv]');
    if (prec) prec.addEventListener('click', function () { aller(idx - 1); });
    if (suiv) suiv.addEventListener('click', function () { aller(idx + 1); });
    vignettes.forEach(function (v) { v.addEventListener('click', function () { aller(+v.getAttribute('data-vignette')); }); });
    points.forEach(function (p) { p.addEventListener('click', function () { aller(+p.getAttribute('data-point')); }); });

    /* --- clavier : flèches gauche / droite quand le focus est dans la galerie --- */
    if (principale && n > 1) {
      principale.setAttribute('tabindex', '0');
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); aller(idx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); aller(idx + 1); }
      });
    }

    /* --- balayage (souris et tactile) --- */
    var drag = null, aGlisse = false;
    if (principale && piste && n > 1) {
      principale.addEventListener('pointerdown', function (e) {
        if (e.button > 0 || e.target.closest('button')) return;
        drag = { x: e.clientX, y: e.clientY, id: e.pointerId, dx: 0, actif: false, t: Date.now() };
      });
      principale.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.actif) {
          if (Math.abs(dx) < 7 || Math.abs(dx) < Math.abs(dy)) return;
          drag.actif = true;
          try { principale.setPointerCapture(e.pointerId); } catch (er) { /* ignoré */ }
          piste.classList.add('est-glisse');
          sortirLoupe();
        }
        drag.dx = dx;
        piste.style.setProperty('--glisse', dx + 'px');
      });
      var finGlisse = function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var d = drag; drag = null;
        if (!d.actif) return;
        piste.classList.remove('est-glisse');
        piste.style.setProperty('--glisse', '0px');
        var l = principale.clientWidth || 1;
        var vitesse = Math.abs(d.dx) / Math.max(1, Date.now() - d.t);
        if (e.type === 'pointerup' && (Math.abs(d.dx) > l * 0.15 || vitesse > 0.5)) aller(idx + (d.dx < 0 ? 1 : -1));
        aGlisse = true;
        window.setTimeout(function () { aGlisse = false; }, 60);   /* évite d'ouvrir le plein écran après un balayage */
      };
      principale.addEventListener('pointerup', finGlisse);
      principale.addEventListener('pointercancel', finGlisse);
    }

    /* --- loupe au survol (la photo agrandie suit la souris) --- */
    var loupeActive = null;
    function sortirLoupe() {
      if (loupeActive) {
        loupeActive.style.transform = '';
        loupeActive.classList.remove('est-zoome');
        loupeActive = null;
      }
    }
    function hautDefinition(d) {
      if (d.__hd) return;
      d.__hd = true;
      var src = d.getAttribute('data-zoom-src');
      var im = d.querySelector('img');
      if (!src || !im) return;
      var hd = new Image();
      hd.onload = function () { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = src; };
      hd.src = src;
    }
    if (principale && zoomSurvol) {
      var raf = 0;
      principale.addEventListener('pointermove', function (e) {
        if (drag && drag.actif) return;
        var d = diapos[idx];
        if (!d || d.classList.contains('galerie__image--vide')) return;
        if (e.target.closest('button')) { sortirLoupe(); return; }
        var loupe = d.querySelector('.galerie__loupe');
        if (!loupe) return;
        var r = d.getBoundingClientRect();
        if (e.clientX-r.left<64 || r.right-e.clientX<64 || e.clientY-r.top<24 || r.bottom-e.clientY<56) { cancelAnimationFrame(raf); sortirLoupe(); return; }
        var x = borne((e.clientX - r.left) / r.width * 100, 0, 100);
        var y = borne((e.clientY - r.top) / r.height * 100, 0, 100);
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          hautDefinition(d);
          loupe.style.setProperty('--zx', x + '%');
          loupe.style.setProperty('--zy', y + '%');
          loupe.style.transform = 'scale(' + niveau + ')';
          loupe.classList.add('est-zoome');
          loupeActive = loupe;
        });
      });
      principale.addEventListener('pointerleave', function () { cancelAnimationFrame(raf); sortirLoupe(); });
    }

    /* --- plein écran --- */
    function ouvrirPleinEcran(declencheur) {
      if (!zoomClic) return;
      var d = diapos[idx];
      if (!d || !d.getAttribute('data-zoom-src')) return;
      if (!lb) lb = creerLightbox(textes);
      lb.ouvrir(api, idx, declencheur);
    }
    if (principale && zoomClic) {
      principale.addEventListener('click', function (e) {
        if (aGlisse || e.target.closest('button')) return;
        ouvrirPleinEcran(principale);
      });
      var agr = g.querySelector('[data-galerie-agrandir]');
      if (agr) agr.addEventListener('click', function (e) { e.stopPropagation(); ouvrirPleinEcran(agr); });
    }

    /* --- fusion automatique : multiply seulement pour les photos à fond blanc --- */
    if (g.getAttribute('data-fusion') === 'auto') {
      var cache = {};
      diapos.forEach(function (d, j) {
        var url = d.getAttribute('data-sonde');
        if (!url) return;
        var appliquer = function (blanc) {
          if (!blanc) return;
          d.setAttribute('data-fond', 'blanc');
          if (vignettes[j]) vignettes[j].setAttribute('data-fond', 'blanc');
        };
        if (url in cache) { cache[url].push(appliquer); return; }
        cache[url] = [appliquer];
        surFondBlanc(url, function (blanc) { cache[url].forEach(function (f) { f(blanc); }); });
      });
    }

    aller(0, true);
    return api;
  }

  /* la photo « collante » se cale sous l'en-tête collant : on mesure sa hauteur réelle (--haut-entete) */
  function mesurerEntete() {
    var h = 0;
    var cand = document.querySelector('header.header, .header, header');
    var el = cand;
    while (el && el !== document.body) {              /* l'élément collant peut être l'en-tête ou son conteneur de section */
      var pos = window.getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') { h = Math.round(el.getBoundingClientRect().height); cand = el; break; }
      el = el.parentElement;
    }
    document.querySelectorAll('[data-produit-grille]').forEach(function (p) { p.style.setProperty('--haut-entete', h + 'px'); });
    return cand;
  }
  var enteteSuivi = false;
  function suivreEntete() {
    var cand = mesurerEntete();
    if (enteteSuivi) return;
    enteteSuivi = true;
    window.addEventListener('resize', mesurerEntete);
    if (cand && window.ResizeObserver) new ResizeObserver(mesurerEntete).observe(cand);
  }

  window.mdmInitGalerie = function (racine) {
    (racine || document).querySelectorAll('[data-galerie]').forEach(function (g) {
      if (g.__galerie) return;
      g.__galerie = creer(g);
    });
    suivreEntete();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.mdmInitGalerie(document); });
  else window.mdmInitGalerie(document);
  document.addEventListener('shopify:section:load', function (e) { window.mdmInitGalerie(e.target); });
})();
